import { Box, Typography } from '@mui/material';
import { PieceHeading } from './PieceHeading';
import {
  HERO_PANEL_BG,
  HERO_PANEL_BORDER,
  HERO_TEXT_EYEBROW,
  HERO_FONT_MONO,
  HERO_WHITE,
} from '../designTokens';

const STATS = [
  { k: 'Active projects', v: '27'   },
  { k: 'Utilisation',     v: '78%'  },
  { k: 'Open pipeline',   v: '£1.4M' },
  { k: 'Conflicts to fix', v: '1'   },
];

export function PieceStats() {
  return (
    <Box sx={{ maxWidth: 520, display: 'flex', flexDirection: 'column', gap: 3 }}>
      <PieceHeading eyebrow="This week at a glance" line1="Plan with confidence." line2="Ship without surprises." />
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          background: HERO_PANEL_BG,
          border: `1px solid ${HERO_PANEL_BORDER}`,
          borderRadius: '12px',
          overflow: 'hidden',
        }}
      >
        {STATS.map((s, i) => (
          <Box
            key={s.k}
            sx={{
              p: '14px 16px',
              borderRight: i % 2 === 0 ? `1px solid ${HERO_PANEL_BORDER}` : 'none',
              borderBottom: i < 2 ? `1px solid ${HERO_PANEL_BORDER}` : 'none',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.65625rem',
                fontFamily: HERO_FONT_MONO,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                color: HERO_TEXT_EYEBROW,
              }}
            >
              {s.k}
            </Typography>
            <Typography
              sx={{
                fontSize: '1.625rem',
                fontWeight: 500,
                letterSpacing: '-0.02em',
                mt: 0.75,
                fontVariantNumeric: 'tabular-nums',
                color: HERO_WHITE,
              }}
            >
              {s.v}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}
